import { InteractableBaseModel } from '../base/InteractableBaseModel';
import { FileType } from './FileType.enum';

export abstract class DatabaseFile extends InteractableBaseModel {
  bucketName: string;
  name: string;
  size: number;
  contentType: string;
  fileType: FileType;
  releaseStatus: DatabaseFileReleaseStatus;
  url: string;
  extension: string;
  metadata: any;
  tags: string[] = [];
  allowedUsages: string[] = [];

  /**
   * The full name of the last editor
   */
  modifiedByName: string;

  variations: BaseDatabaseFileVariation[];
}

export enum DatabaseFileReleaseStatus {
  Private = 'Private',
  Public = 'Public'
}

export class BaseDatabaseFileVariation {
    /**
   * File variation names
   */
    name: string;

    /**
     * The size of the file in bytes
     */
    size: number;
  
    /**
     * The file content type e.g. image/png
     */
    contentType: string;
  
    /**
     * The default variation normally the original
     */
    isDefault: boolean;
  
    /**
     * The public url for varnish.
     * Remark: This is only used for audios. For images,
     * urls can be generated based on the file id.
     * <BaseUrl>/<Id>/<VariationName> (in case of an image), e.g.
     * https://image.speakyfox.com/3f55f6a9-8701-4b14-a576-fff856894a5f/Original
     */
    url: string;
}

export class DatabaseFileImageVariation extends BaseDatabaseFileVariation {

}

export class DatabaseFileAudioVariation extends BaseDatabaseFileVariation {
  /**
   * The gender of the audio
   */
  gender: string;

  /**
   * Must be in between 0.25 and 4.0 (requirement by Google)
   */
  speedRate: string;

  /**
   * The extension of the file, e.g. .mp3, .png
   */
  extension: string;
}